import { Link } from "react-router-dom";
import SeriesNavigation from "../../components/SeriesNavigation";
import { leadershipMembers } from "../../data/navigationData";
import SEO from "../../components/SEO";

export default function SimoneSchoenwaelder() {
  const simoneSchoenwaelderSchema = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Simone Schoenwaelder",
    "jobTitle": "Head, Biology",
    "affiliation": {
      "@type": "Organization",
      "name": "Thrombio"
    },
    "url": "https://www.thrombio.com.au/leadership/simone-schoenwaelder"
  };

  return (
    <div className="seniorManagementBg" style={{"--bg-opacity": "0.2"}}>
      <SEO
        title="Simone Schoenwaelder - Head, Biology"
        description="Simone has >25 years experience in medical research, working in the field of cell biology, namely platelet biology and function."
        keywords={['Simone Schoenwaelder', 'Head Biology', 'Platelet Biology', 'Medical Research', 'NHMRC']}
        ogImage="/simoneSchoenwaelder.webp"
        schema={simoneSchoenwaelderSchema}
      />

      <div className="xl:page-width px-12 pt-[18px] pb-8">
        <nav className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2 font-sans text-[2rem] font-normal leading-[2rem]" aria-label="Breadcrumb">
          <Link to="/leadership/senior-management" className="text-white hover:text-primary-red transition-colors">
            Senior Management
          </Link>
          <div className="flex items-center gap-2">
            <span className="text-white">/</span>
            <span className="text-[#5C95A4]">Simone Schoenwaelder</span>
          </div>
        </nav>

        <div className="flex flex-col gap-2 md:gap-4 pt-24">
          <div className="text-[3.8rem] md:text-[4.8rem] font-bold leading-[4.2rem] md:leading-[5.2rem] tracking-[.19rem] drop-shadow-[0_4px_8.9px_#000]">
            Simone Schoenwaelder
          </div>
          <div className="font-syne font-bold text-left justify-start text-[#e0ffff] text-[2.9rem] font-medium leading-[3.6rem] tracking-[.096rem] [text-shadow:_2px_4px_5px_rgb(0_0_0_/_1.00)]">
            Head, Biology
          </div>
        </div>
      </div>

      <div className="pt-[50px] xl:pt-[90px] xl:pb-[80px] xl:page-width px-12">
        <div className="w-full">
          <div className="grid lg:grid-cols-12 gap-16 items-start">
            <div className="lg:col-span-3">
              <img 
                src="/simoneSchoenwaelder.webp" 
                alt="Simone Schoenwaelder, Head, Biology: Experienced Medical Researcher in Blood Clotting and Platelet Biology" 
                className="w-full max-w-[300px] mx-auto md:max-w-[300px] md:mx-0"
                width={650} 
                height={650} 
              />
            </div>
            
            <div className="lg:col-span-8 flex flex-col">
              <div className="font-sans text-[2.1rem] leading-[3.1rem] tracking-[.042rem] text-white">
                Simone has &gt;25 years experience in medical research, working in the field of cell biology, namely platelet biology and function. After receiving her doctorate from Monash University (Victoria), she completed postdoctoral at the University of North Carolina (Chapel Hill) with Professor Keith Burridge, supported by an NHMRC CJ Martin Fellowship. Her research has been continually funded through competitive grants from the NHMRC, NHF and Department of Health (NSW). She has received numerous awards throughout her career, including a Victorian Premier's Award for Medical Research Commendation (1997); Young Australian of the Year - State winner, for science and technology (Victoria, 1999) and National Finalist, Young Australian of the Year (1999); City of Whitehorse Young Citizen of the Year (1999); and the THANZ Scientific Medal awarded by the Thrombosis and Haemostasis society of Australia and New Zealand in 2007.
              </div>
            </div>
          </div>
        </div>
      </div>
      <SeriesNavigation 
      items={leadershipMembers} 
      currentSlug="simone-schoenwaelder" 
      basePath="/leadership" 
    />
    </div>
  );
}